<template>
  <div>
    <Row :gutter="8" style="margin: 10px 0 0 0; width: 100%">
      <Table :columns="tableCols" :data="data2" :table="table" :border="table.border" :stripe="table.stripe"
        :header="table.header" :footer="table.footer" :columns-list="tableCols">
      </Table>
    </Row>

    <Form ref="formDynamic" :model="formDynamic" :label-width="80" style="width: 900px; margin-top: 30px">
      <FormItem label="核算科室:">
        <el-cascader style="width: 400px" filterable v-model="checkDeskId" :options="checkDeskList"
          :props="checkDeskKey" clearable @change="getName"></el-cascader>
      </FormItem>
      <FormItem label="科室信息:">
        <Select v-model="deskId" :filterable="true" style="width: 400px" @on-change="onDeskChange">
          <Option v-for="item in deskList" :value="item.id" :key="item.id">{{
            item.deskName
          }}</Option>
        </Select>
      </FormItem>
      <FormItem label="领用人:">
        <Input type="text" v-model="receive" style="width: 400px" @input="checkFormComplete"></Input>
      </FormItem>

      <!-- 设备选择区域 -->
      <div v-if="showFacilitySelection && facilitySelectionList.length > 0">
        <Divider orientation="left">设备绑定</Divider>
        <div v-for="(item, index) in facilitySelectionList" :key="index" style="margin-bottom: 20px;">
          <h4>{{ item.name }} - {{ item.brand }} ({{ item.model }})</h4>
          <div v-for="(facility, fIndex) in item.facilities" :key="fIndex" style="margin-bottom: 10px;">
            <FormItem :label="`第${fIndex + 1}个:`" style="margin-left: 20px;">
              <Select v-model="facility.facilityId" :filterable="true" style="width: 400px"
                :class="{ 'facility-select-required': !facility.facilityId }" placeholder="请选择关联设备" clearable
                @on-change="onFacilityChange($event, index, fIndex)">
                <Option v-for="val in facilityList" :value="val.value" :key="val.value">
                  {{ val.label }}
                </Option>
              </Select>
              <!-- <span v-if="!facility.facilityId" style="color: red; font-size: 12px; margin-left: 5px;">
                * 必须绑定设备
              </span> -->
            </FormItem>
          </div>
        </div>
      </div>
      <FormItem>
        <Button type="primary" @click="handleSubmit()">保存</Button>
      </FormItem>
    </Form>
  </div>
</template>
<script>
import { IMAGE_HOST } from "@/../config";
export default {
  props: {
    consumableInventory: [],
  },
  data() {
    return {
      table: {
        mname: "consumables",
        key: "id",
        url: {},
        output: false,
        border: true,
        rows: [],
        stripe: true,
        header: false,
        footer: false,
        order: "",
        router: {
          add: "",
          edit: "",
        },
      },
      formDynamic: {},
      index: 1,
      desk: "",
      receive: "",
      main: "",
      checkDeskId: "",
      checkDeskKey: {
        value: "id",
        label: "checkDeskName",
        checkStrictly: true,
        emitPath: false,
      },
      checkDeskList: [],
      deskList: [],
      data2: [],
      deskId: "",
      facilityList: [], // 设备列表
      showFacilitySelection: false, // 是否显示设备选择区域
      tableCols: [
        {
          title: "货物信息",
          width: 530,
          align: "center",
          render: (h, p) => {
            return h("div", [
              h("img", {
                style: {
                  width: "60px",
                  height: "60px",
                  float: "left",
                  margin: "10px",
                  display: "block",
                },
                attrs: { src: IMAGE_HOST + p.row.consumableImgUrl },
              }),
              h("div", [
                h(
                  "span",
                  {
                    style: {
                      display: "inline-block",
                      float: "left",
                      marginTop: "5px",
                      marginLeft: "9px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    },
                    domProps: {
                      title: p.row.brand,
                    },
                  },
                  p.row.brand
                ),
                h(
                  "span",
                  {
                    style: {
                      display: "inline-block",
                      marginTop: "5px",
                      marginLeft: "5px",
                      float: "left",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    },
                    domProps: {
                      title: p.row.name,
                    },
                  },
                  p.row.name
                ),
              ]),
              h(
                "span",
                {
                  style: {
                    display: "inline-block",
                    marginTop: "5px",
                    width: "80%",
                    textAlign: "left",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  },
                  domProps: {
                    title: "型号:" + p.row.model,
                  },
                },
                "型  号: " + p.row.model
              ),
              h(
                "span",
                {
                  style: {
                    display: "inline-block",
                    width: "80%",
                    textAlign: "left",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  },
                  domProps: {
                    title: "适用于: " + p.row.remark,
                  },
                },
                "适用于: " + p.row.remark
              ),
            ]);
          },
        },
        {
          title: "库存",
          key: "num",
          minWidth: 80,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.num;
            return h(
              "div",
              {
                style: {
                  color: row.num <= 10 ? "red" : "",
                  "font-size": "14px",
                  overflow: "hidden",
                  "text-overflow": "ellipsis",
                  "white-space": "nowrap",
                },
              },
              text
            );
          },
        },
        {
          title: "单位",
          key: "unit",
          minWidth: 80,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.unit;
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "领用数量",
          key: "receiveNum",
          minWidth: 120,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.receiveNum;
            return h(
              "InputNumber",
              {
                props: {
                  min: 1,
                  max: 100,
                  value: params.row.receiveNum,
                },
                on: {
                  "on-change": (event) => {
                    this.data2[params.index].receiveNum = event;
                    this.updateFacilitySelection();
                  },
                },
                style: {
                  "font-size": "14px",
                  overflow: "hidden",
                  "text-overflow": "ellipsis",
                  "white-space": "nowrap",
                },
              },
              params.row.receiveNum
            );
          },
        },
      ],
      facilitySelectionList: [], // 需要选择设备的耗材列表
    };
  },
  async created() {
    let arr = this.consumableInventory;
    for (let i = 0; i < arr.length; i++) {
      let consumableIn = {};
      consumableIn.inventoryId = arr[i].inventoryId;
      consumableIn.consumableNum = arr[i].consumableNum;
      consumableIn.consumableImgUrl = arr[i].consumableImgUrl;
      consumableIn.brand = arr[i].brand;
      consumableIn.name = arr[i].name;
      consumableIn.model = arr[i].model;
      consumableIn.remark = arr[i].remark;
      consumableIn.num = arr[i].num;
      consumableIn.unit = arr[i].unit;
      consumableIn.receiveNum = arr[i].receiveNum || 1; // 默认领用数量为1
      this.data2.push(consumableIn);
    }
    this.getCheckDeskList();
    this.checkData();
    await this.deskListMethod();
  },
  methods: {
    getName(e) {
      let list = this.checkDeskList;
      for (let i = 0; i < list.length; i++) {
        const item = list[i].children;
        if (item && item.length > 0) {
          item.forEach((child) => {
            if (e == child.id) {
              this.checkDeskId = child.id;
            }
          });
        }
      }
    },
    async getCheckDeskList() {
      let d = {};
      let res = await $utils.api.load("admin/system/check/list", d, "get");
      if (res.code == 200) {
        let data = res.rows;
        if (data && data.length > 0) {
          const processedRows = data.map((item) => ({
            ...item,
            disabled: true,
          }));
          const updatedResponseData = {
            rows: processedRows,
          };
          this.checkDeskList = updatedResponseData.rows;
        } else {
          this.checkDeskList = [];
        }
      }
    },
    async deskListMethod() {
      let res = await $utils.api.load("/admin/system/desk/selectList");
      this.deskList = res.rows;
      for (let i = 0; i < this.deskList.length; i++) {
        let workInfotemp = "";
        if (
          this.deskList[i].deskName !== null &&
          this.deskList[i].deskName !== undefined
        ) {
          workInfotemp = this.deskList[i].deskName;
        }
        if (
          this.deskList[i].principal !== null &&
          this.deskList[i].principal !== undefined
        ) {
          workInfotemp = workInfotemp + "/" + this.deskList[i].principal;
        }
        if (this.deskList[i].phone !== null && this.deskList[i].phone !== undefined) {
          workInfotemp = workInfotemp + "/" + this.deskList[i].phone;
        }
        if (this.deskList[i].address !== null && this.deskList[i].address !== "") {
          workInfotemp = workInfotemp + "/" + this.deskList[i].address;
        }
        this.deskList[i].deskName = workInfotemp;
      }
    },
    // 科室选择变化时的处理
    onDeskChange() {
      this.checkFormComplete();
    },
    // 检查表单是否完整并更新设备选择
    async checkFormComplete() {
      if (this.checkDeskId && this.deskId && this.receive.trim()) {
        await this.loadFacilityList();
        this.updateFacilitySelection();
        this.showFacilitySelection = true;
      } else {
        this.showFacilitySelection = false;
        this.facilitySelectionList = [];
      }
    },
    // 加载设备列表
    async loadFacilityList() {
      try {
        let q = {
          state: 2,
          deskId: this.deskId
        };
        let res = await $utils.api.load(
          "/admin/system/facility/selectListSearch",
          q,
          "get"
        );
        this.facilityList = res.rows.map(item => ({
          value: item.id,
          label: item.facilityName + "/" + item.facilityType + "/" + item.assetNum
        }));
      } catch (error) {
        console.error('加载设备列表失败:', error);
        this.facilityList = [];
      }
    },
    // 更新设备选择列表
    updateFacilitySelection() {
      const newList = [];

      this.data2.forEach(item => {
        if (item.receiveNum && item.receiveNum > 0) {
          // 查找已存在的选择项
          const existingSelection = this.facilitySelectionList.find(fs => fs.inventoryId === item.inventoryId);

          const facilitySelection = {
            inventoryId: item.inventoryId,
            name: item.name,
            brand: item.brand,
            model: item.model,
            facilities: []
          };

          // 根据领用数量创建或更新设备选择项
          for (let i = 0; i < item.receiveNum; i++) {
            if (existingSelection && existingSelection.facilities[i]) {
              // 保留已有的选择
              facilitySelection.facilities.push({
                facilityId: existingSelection.facilities[i].facilityId,
                facilityName: existingSelection.facilities[i].facilityName
              });
            } else {
              // 创建新的选择项
              facilitySelection.facilities.push({
                facilityId: '',
                facilityName: ''
              });
            }
          }
          newList.push(facilitySelection);
        }
      });
      this.facilitySelectionList = newList;
    },
    // 设备选择变化时的处理
    onFacilityChange(facilityId, itemIndex, facilityIndex) {
      const selectedFacility = this.facilityList.find(f => f.value === facilityId);
      if (selectedFacility) {
        this.facilitySelectionList[itemIndex].facilities[facilityIndex].facilityName = selectedFacility.label;
      }
    },
    // 校验设备绑定
    validateFacilityBindings() {
      const unboundItems = [];

      // 遍历有领用数量的耗材
      for (let i = 0; i < this.data2.length; i++) {
        const item = this.data2[i];
        if (item.receiveNum && item.receiveNum > 0) {
          // 查找对应的设备选择信息
          const facilitySelection = this.facilitySelectionList.find(fs => fs.inventoryId === item.inventoryId);

          if (!facilitySelection) {
            unboundItems.push({
              name: `${item.brand} ${item.name}`,
              model: item.model,
              receiveNum: item.receiveNum,
              unboundCount: item.receiveNum
            });
            continue;
          }

          // 检查每个设备绑定
          const unboundCount = facilitySelection.facilities.filter(f => !f.facilityId || f.facilityId === '').length;
          if (unboundCount > 0) {
            unboundItems.push({
              name: `${item.brand} ${item.name}`,
              model: item.model,
              receiveNum: item.receiveNum,
              unboundCount: unboundCount
            });
          }
        }
      }

      if (unboundItems.length > 0) {
        if (unboundItems.length === 1) {
          const item = unboundItems[0];
          return {
            isValid: false,
            message: `${item.name}(${item.model}) 还有 ${item.unboundCount} 个设备未绑定，请完成绑定后再提交！`
          };
        } else {
          let message = `有 ${unboundItems.length} 种耗材未完成设备绑定`;
          return {
            isValid: false,
            message: message.trim()
          };
        }
      }

      return {
        isValid: true,
        message: ""
      };
    },
    async handleSubmit() {
      if (!this.checkDeskId) {
        return $utils.toast.error("请选择核算科室!");
      }
      if (!this.deskId) {
        return $utils.toast.error("请选择科室!");
      }
      if (!this.receive.trim()) {
        return $utils.toast.error("请填写领用人!");
      }

      // 检查是否有耗材需要领用
      const hasReceiveItems = this.data2.some(item => item.receiveNum && item.receiveNum > 0);
      if (!hasReceiveItems) {
        return $utils.toast.error("请至少选择一种耗材进行领用!");
      }

      // 校验设备绑定（只有当显示设备选择区域时才进行校验）
      if (this.showFacilitySelection) {
        /* const validationResult = this.validateFacilityBindings();
        if (!validationResult.isValid) {
          return $utils.toast.error(validationResult.message);
        } */
      }

      // 构建耗材列表，包含设备绑定信息
      let consumableList = this.data2
        .filter(item => item.receiveNum && item.receiveNum > 0) // 只包含有领用数量的项
        .map(item => {
          const consumable = { ...item };

          // 查找对应的设备选择信息
          const facilitySelection = this.facilitySelectionList.find(fs => fs.inventoryId === item.inventoryId);
          if (facilitySelection) {
            /* .filter(f => f.facilityId) // 只包含已选择设备的项 必须选择设备时把这个添加到后面 */
            consumable.sysConsumableFacilityList = facilitySelection.facilities
              .map(f => ({
                facilityId: f.facilityId ? f.facilityId : null,
              }));
          } else {
            consumable.sysConsumableFacilityList = [];
          }
          return consumable;
        });
      let q = {
        consumableList: consumableList,
        deskId: this.deskId,
        receive: this.receive,
        checkDeskId: this.checkDeskId,
      };
      let res = await $utils.api.load("/admin/system/inventory/receive", q, "put");
      if (res.code == 200) {
        await $utils.toast.success("提交成功");
        $utils.url.go(0);
        this.$Modal.remove();
      } else {
        $utils.toast.error(res.message);
      }
    },
    checkData() {
      this.data2 = this.consumableInventory;
    },
    handleRemove(index) {
      this.formDynamic.items[index].status = 0;
    },
  },
};
</script>

<style scoped>
.facility-select-required .ivu-select-selection {
  border-color: #ed4014 !important;
  box-shadow: 0 0 0 2px rgba(237, 64, 20, 0.2) !important;
}

.facility-select-required .ivu-select-selection:hover {
  border-color: #ed4014 !important;
}
</style>
